export default "__VITE_ASSET__viDGqTJi__"